// store/auth-slice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  authType: "signin", // 'signin' | 'signup'
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    openAuthModal: (state, action) => {
      state.isOpen = true;
      state.authType = action.payload;
    },

    closeAuthModal: (state) => {
      state.isOpen = false;
    },

    switchAuthType: (state, action) => {
      state.authType = action.payload;
    },
  },
});

// Actions
export const {
  openAuthModal,
  closeAuthModal,
  switchAuthType,
} = authSlice.actions;

// Selectors
export const selectAuth = (state) => state.auth;

export const selectIsAuthModalOpen = (state) => state.auth.isOpen;

export const selectAuthType = (state) => state.auth.authType;

// Reducer
export default authSlice.reducer;